<app-page-overlay (closeOverlay)="onClickCancel()">
    <ng-container *ngIf="!isRequestConnection">

        <div class="overlay-content">

            <div class="overlay-header">
                <div class="header-text">Connect with Party</div>
                <div class="header-label">You can send a request to connect and coordinate travel plans</div>
            </div>

            <div class="user-card">
                <div class="creator-name">
                    {{privateName}}
                </div>

                <div class="detail-row">
                    <!-- <div class="detail-item linkedin" [ngClass]="{'active' : isLinkedInConnected}">
                        <div class="icon">
                            <app-svg-loader height="12px"
                                url="assets/third-party-logos/logo-linkedin.svg"></app-svg-loader>
                        </div>
                        <div class="value" *ngIf="isLinkedInConnected">{{linkedInStat}}</div>
                        <div class="value" *ngIf="!isLinkedInConnected">Not Connected</div>
                    </div> -->
                    <div class="detail-item review" [ngClass]="{'active' : isReviewed}">
                        <div class="icon">
                            <app-svg-loader height="12px" url="assets/svg/star-solid.svg"></app-svg-loader>
                        </div>
                        <!-- // TODO Wire up review -->
                        <div class="value" *ngIf="isReviewed">{{reviewStat}}</div>
                        <div class="value" *ngIf="!isReviewed">No Reviews</div>
                    </div>
                </div>
            </div>

            <div class="card-label">Their travel plan:</div>
            <div class="flight-detail-card">

                <div class="location-row">
                    <div class="location">
                        {{l(flightOption.departureLocationName)}}
                        <span class="airport-code">({{flightOption.departureAirportCode}})</span>
                    </div>
                    <div class="arrow">
                        <app-svg-loader height="14px" url="assets/svg/chev-bold-right.svg"></app-svg-loader>
                    </div>
                    <div class="location" *ngIf="flightOption.arrivalLocationName">
                        {{l(flightOption.arrivalLocationName)}}
                        <span class="airport-code">({{flightOption.arrivalAirportCode}})</span>
                    </div>
                    <div class="location" *ngIf="!flightOption.arrivalLocationName">
                        Any {{flightOption.arrivalGeneralType}}
                        <ng-container *ngIf="flightOption.arrivalGeneralState || flightOption.arrivalGeneralCountry">
                            in
                            <span *ngIf="flightOption.arrivalGeneralState">{{flightOption.arrivalGeneralState}}</span>
                            <span *ngIf="flightOption.arrivalGeneralState && flightOption.arrivalGeneralCountry">,
                            </span>
                            <span
                                *ngIf="flightOption.arrivalGeneralCountry">{{flightOption.arrivalGeneralCountry}}</span>
                        </ng-container>
                    </div>
                </div>

                <div class="detail-row">
                    <div class="detail">
                        <div class="icon">
                            <app-svg-loader height="14px" url="assets/svg/cal-solid.svg"></app-svg-loader>
                        </div>
                        <div class="value" *ngIf="flightOption.departureDateExact; else dateRangeTemplate">
                            {{d(flightOption.departureDateExact)}}</div>
                        <ng-template #dateRangeTemplate>
                            <div class="value">
                                {{d(flightOption.departureDateRangeStart)}} - {{d(flightOption.departureDateRangeEnd)}}
                            </div>
                        </ng-template>
                    </div>
                    <div class="detail">
                        <div class="icon">
                            <app-svg-loader height="14px" url="assets/svg/clock-solid.svg"></app-svg-loader>
                        </div>
                        <div class="value" *ngIf="flightOption.departureTimeExact; else timeRangeTemplate">
                            {{t(flightOption.departureTimeExact)}} {{timezone}}</div>
                        <ng-template #timeRangeTemplate>
                            <div class="value">
                                {{t(flightOption.departureTimeRangeStart)}} - {{t(flightOption.departureTimeRangeEnd)}}
                                -
                                {{timezone}}
                            </div>
                        </ng-template>
                    </div>
                </div>

                <div class="detail-row">
                    <div class="detail">
                        <div class="icon">
                            <app-svg-loader height="14px" url="assets/svg/seat-cube.svg"></app-svg-loader>
                        </div>
                        <div class="value" *ngIf="flightOption.seatsNeeded; else seatsOfferedTemplate">
                            {{flightOption.seatsNeeded}}
                            Seats Needed</div>
                        <ng-template #seatsOfferedTemplate>
                            <div class="value">
                                {{flightOption.seatsOffered}} Seats Available
                            </div>
                        </ng-template>
                    </div>
                </div>

            </div>

            <div class="card-label">Their aircraft and travel preferences</div>
            <div class="aircraft-card">
                <div class="aircraft">{{flightOption.aircraft}}</div>

                <div class="detail-row">
                    <app-flight-secondary-data label="Max seats (Their Configuration)"
                        [value]="flightOption.aircraftMaxSeats"></app-flight-secondary-data>

                    <app-flight-secondary-data label="Estimated flight hours"
                        [value]="flightOption.estimatedFlightHours"></app-flight-secondary-data>

                    <app-flight-secondary-data label="Bringing Children Under 12"
                        [value]="flightOption.isBringingChildren ? 'Yes' : 'No'"></app-flight-secondary-data>

                    <app-flight-secondary-data label="Children Ok"
                        [value]="flightOption.isChildrenOk ? 'Yes' : 'No'"></app-flight-secondary-data>

                    <app-flight-secondary-data label="Bringing Pets"
                        [value]="flightOption.isBringingPets ? 'Yes' : 'No'"></app-flight-secondary-data>

                    <app-flight-secondary-data label="Pets Ok"
                        [value]="flightOption.isPetsOk ? 'Yes' : 'No'"></app-flight-secondary-data>
                </div>
            </div>

            <div class="button-wrapper">
                <div class="disabled-message" *ngIf="isAlreadyRequested">You have already sent a request</div>
                <div class="disabled-message" *ngIf="isUserBlocked">You cannot send a request</div>
                <app-primary-btn mb="12px" [gradient]="true" [disabled]="isAlreadyRequested || isUserBlocked" (click)="onClickRequest()">
                    Request to Connect
                </app-primary-btn>
                <app-secondary-btn (click)="onClickCancel()">
                    Close
                </app-secondary-btn>
            </div>

        </div>

    </ng-container>


    <ng-container *ngIf="isRequestConnection && !isRequestSent">

        <div class="overlay-content">
            <div class="overlay-header">
                <div class="header-pre-label">Connect with</div>
                <div class="header-text">{{privateName}}</div>
            </div>

            <div class="card slider-card" *ngIf="!isLoadingData">
                <div class="inputs">
                    <div class="slider-value">for the <span class="highlight">{{numberOfSeats}}</span> seats I need
                    </div>
                    <input type="range" min="1" [max]="maxSeats" [(ngModel)]="numberOfSeats" class="slider"
                        (input)="onSlideSeatsValue($event)">
                    <div class="sub-message">Max {{maxSeats}} Available</div>
                </div>
            </div>

            <div class="flex j-between">
                <div class="card-label">Message</div>
                <div class="card-label">(Required)</div>
            </div>

            <app-base-text-area id="message" placeholder="Let them know how you'd like to coordinate this flight" mb="8px"
                [(ngModel)]="requestMessage" (ngModelChange)="onRequestMessageChange($event)" isFluid="true"
                autocomplete="off"></app-base-text-area>
            <div class="error-text" *ngIf="messageError">{{messageError}}</div>

            <div class="button-wrapper">
                <app-primary-btn mb="12px" [disabled]="isSendingRequest || isAlreadyRequested || isUserBlocked || !requestMessage?.trim()"
                    [isLoading]="isSendingRequest" (click)="onSendRequest()">
                    Send Request
                </app-primary-btn>
                <app-secondary-btn (click)="onClickCancel()">
                    Cancel
                </app-secondary-btn>
            </div>
        </div>
    </ng-container>

    <ng-container *ngIf="isRequestConnection && isRequestSent">

        <div class="overlay-content">
            <div class="prompt-wrapper">
                <app-icon-prompt-card iconURL="assets/svg/flight-shape-solid.svg" label="Request Sent To"
                    [header]="privateName"
                    desc="You will receive an email if this party accepts and wishes to coordinate"
                    btnText="Got it" (handleBtnClick)="onClickDone()"></app-icon-prompt-card>
            </div>
        </div>

    </ng-container>

</app-page-overlay>
